import React from 'react';
import { v4 as uuid } from 'uuid';

import type { OnErrorType } from '@xing-com/crate-social-common-share';
import type { BackendTrackingMetaData } from '@xing-com/crate-social-types';

import { ShareTabView } from '../../internal-share/share-tab-view/share-tab-view';
import { ShareFeedback } from '../share-feedback/share-feedback';
import { ShareTabHeader } from '../share-tab-header/share-tab-header';

export type ShareTabFrameType = {
  backendTrackingMetaData?: BackendTrackingMetaData;
  entryPoint?: string;
  interactionTargetUrn?: string;
  onCancel?: () => void;
  onError?: OnErrorType;
  onSuccess: () => void;
  openWithShareTo?: 'MESSENGER' | 'FEED';
  propChannel?: string;
  propSourceType?: string;
  url: string;
  verb?: 'SHARE' | 'POST';
};

export const ShareTabFrame: React.FC<ShareTabFrameType> = ({
  backendTrackingMetaData = { trackingTokens: [], page: '', position: '' },
  entryPoint = '',
  interactionTargetUrn = '',
  onCancel = () => window.history.back(),
  onError = () => undefined,
  onSuccess,
  openWithShareTo,
  propChannel = '',
  propSourceType = '',
  url,
  verb = 'POST',
}) => {
  const propSocialInteractionId = React.useRef(uuid()).current;

  const [successProps, setSuccessProps] = React.useState({
    redirectUrl: '',
    targetType: '',
  });

  const hadSuccess = successProps.redirectUrl || successProps.targetType;

  return (
    <div>
      <ShareTabHeader />
      {hadSuccess ? (
        <ShareFeedback {...{ ...successProps, onCancel }} />
      ) : (
        <ShareTabView
          {...{
            backendTrackingMetaData,
            interactionTargetUrn,
            onSuccess: ({ redirectUrl, targetType }) => {
              setSuccessProps({ redirectUrl, targetType });
              onSuccess();
            },
            entryPoint,
            onCancel,
            onError,
            openWithShareTo,
            propChannel,
            propSocialInteractionId,
            propSourceType,
            url,
            verb,
          }}
        />
      )}
    </div>
  );
};
